import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WarehousingCreationService {

  constructor(
    private http: HttpClient
  ) { }


  addWarehousing(warehousingForm: any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/add/warehousing`;
    return this.http.post(url, warehousingForm);
  }


  preview(file: any): Observable<any>{
    let url = `${environment.logisticsApiUrl}/warehousing/preview/warehousingExcel`;
    const formData: FormData = new FormData();
    formData.append('file', file);
    let response = this.http.post(url, formData ,  {
      reportProgress: true,
      responseType: 'json'
    } );
    return response;
  }

  uploadFile(file: any, createUser : string): Observable<any>{

    let url = `${environment.logisticsApiUrl}/warehousing/file/warehousing`;

    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('createUser', createUser);

    let response = this.http.post(url, formData ,  {
      reportProgress: true,
      responseType: 'json'
    } );
    return response;
  }


}
